export const ENVIRONMENTS = {
  qa: 'qa',
  dev: 'dev',
};
